/**
 * Temporärer In-Memory-Speicher für File-Objekte, die vom AddImmobilieModal
 * an die AnalysePage übergeben werden. File-Objekte sind nicht über den
 * History-State serialisierbar, daher diese Singleton-Lösung.
 *
 * Konsum erfolgt zeitbasiert: innerhalb des Fensters mehrfach lesbar (damit
 * React-StrictMode-Doppelmount in Dev nicht den State leert), danach
 * automatisch verfallen — verhindert Leaks bei Hin-/Hernavigation.
 */
const PENDING_TTL_MS = 5_000;
let pending: File[] = [];
let pendingAt = 0;

export function setPendingFiles(files: File[]): void {
  pending = [...files];
  pendingAt = Date.now();
}

/** Liest die gespeicherten Dateien, sofern frisch genug. Mehrfach lesbar im TTL-Fenster. */
export function consumePendingFiles(): File[] {
  if (Date.now() - pendingAt > PENDING_TTL_MS) {
    pending = [];
    pendingAt = 0;
    return [];
  }
  return pending;
}
